import apiRoutes from '@constants/apiRoutes';
import baseApi from '@services/api';
import { ApiResponse } from './types/common';
import {
  AdminClientUsersListingRequest,
  AdminClientUsersListingItem,
  AdminEditClientCompanyDashboardsRequest,
} from './types/clientUsers';
import { PaginatedResponse } from './types/common';
import { buildQueryParams } from '../utils/query';

const clientUsers = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getClientUsers: builder.query<
      PaginatedResponse<AdminClientUsersListingItem>,
      AdminClientUsersListingRequest
    >({
      query: ({ pageNumber, pageSize, search, sort, sortOrder, role, status }) =>
        `${apiRoutes.clientUsers}?${buildQueryParams(
          { pageNumber, pageSize, search, sort, sortOrder },
          { role, status },
        )}`,
    }),
    editClientDashboards: builder.mutation<
      ApiResponse<string>,
      AdminEditClientCompanyDashboardsRequest
    >({
      query: ({ clientCode, payload }) => ({
        url: apiRoutes.clientUserManagementDashboards(clientCode),
        method: 'PUT',
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetClientUsersQuery,
  useLazyGetClientUsersQuery,
  useEditClientDashboardsMutation,
} = clientUsers;
